import Head from 'next/head';
import React from 'react';
import Styles from './CDCProtegido25.css';
import CDCProtegido25Protecao from '@/components/organisms/CDCProtegido25Protecao';
import CDCProtegido25Condicoes from '@/components/organisms/CDCProtegido25Condicoes';
import CDCProtegido25AvisarSinistro from '@/components/organisms/CDCProtegido25AvisarSinistro';
import CDCProtegido25Informacoes from '@/components/organisms/CDCProtegido25Informacoes';
import FaqLPs25 from '@/components/molecules/FaqLPs25';

function CDCProtegido25() {
  const faqTitle = 'Saiba mais sobre seguro e confira nossos canais';
  const imgpng = 'assets/cdc25/perguntas/img-perguntas.jpg';
  const imgwebp = 'assets/cdc25/perguntas/img-perguntas.webp';
  const imgpngdesk = 'assets/cdc25/perguntas/img-perguntas-desk.jpg';
  const imgwebpdesk = 'assets/cdc25/perguntas/img-perguntas-desk.webp';
  const imgalt =
    'Mulher no banco traseiro de um carro, pesquisando sobre o seguro de proteção financeira na Santander Financiamentos.';
  const linkMostrarTodasPerguntas = 'duvidas-frequentes.html';
  const faqs = [
    {
      pergunta: 'Como comunicar ou acompanhar um sinistro?',
      resposta: `Através do app Santander Auto, disponível para IOS e Android, você pode comunicar e acompanhar o sinistro, realizar o envio de documentos, agendar e realizar vistoria e falar com o analista do processo. Também é possível comunicar e acompanhar o processo de sinistro de forma digital, através do Portal do Segurado ou em nossa Central de Sinistros, disponível de segunda a sexta, das 08:00 às 20:00, através do telefone 0800 201 9500.`,
    },
    {
      pergunta: 'Como solicitar o carro reserva?',
      resposta: `Em casos de roubo e furto, a liberação do carro reserva é realizada após a comunicação do sinistro e apresentação do B.O (Boletim de ocorrência). Em casos de colisão em que o valor dos reparos fique acima do valor da franquia, a liberação é realizada após autorização dos reparos. Para realizar o agendamento da retirada do carro reserva, é necessário entrar em contato com a central de atendimento, através do telefone 0800 201 9500 - opção 4 ou no Whatsapp 55 (31) 97139-1451, disponível de segunda a sexta, das 08h às 20h, e aos sábados, das 08h às 14h. `,
    },
    {
      pergunta: 'Qual a diferença entre Seguro Auto e Seguro Proteção Financeira?',
      resposta: `O Seguro Auto é voltado para o seu veículo, enquanto o seu Seguro Proteção Financeira é pessoal, ou seja, voltado para quem realizar o financiamento do veículo ou bem. `,
    },
    {
      pergunta: 'O que é sinistro?',
      resposta: `Sinistro é quando ocorre um evento em que o bem segurado sofre um acidente ou prejuízo material, como roubo, furto ou colisão.`,
    },
  ];
  return (
    <>
      <Head>
        <title>Santander Seguro Proteção | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Proteja seu futuro com o Seguro Prestamista: adquira no momento do financiamento e garanta sua segurança sem complicação, online e direto de onde estiver!"
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="Seguro proteção renda familiar,Proteção contra desemprego,Seguro prestamista Santander,Seguro Santander proteção renda,Seguro financeiro para veículo,Seguro com sorteios mensais,Seguro pessoal financeiro,Seguro contra invalidez,Santander CDC protegido,Seguro com capitalização,Seguro com assistência digital,Seguro vida financiamento,Seguro para imprevisto"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/cdc-protegido.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Santander Seguro Proteção | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/cdc-protegido.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Proteja seu futuro com o Seguro Prestamista: adquira no momento do financiamento e garanta sua segurança sem complicação, online e direto de onde estiver!"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/cdc25/hero/hero-1440.webp"
        />
        <meta
          property="og:image:alt"
          content="Mulher sorridente desbloqueando o carro com o celular, representando segurança e tranquilidade proporcionadas pelo seguro de proteção financeira da Santander Financiamentos."
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Santander Seguro Proteção | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Proteja seu futuro com o Seguro Prestamista: adquira no momento do financiamento e garanta sua segurança sem complicação, online e direto de onde estiver!"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/cdc-protegido.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/cdc25/hero/hero-1440.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Mulher sorridente desbloqueando o carro com o celular, representando segurança e tranquilidade proporcionadas pelo seguro de proteção financeira da Santander Financiamentos."
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <CDCProtegido25Protecao />
      <CDCProtegido25AvisarSinistro />
      <CDCProtegido25Condicoes />
      <CDCProtegido25Informacoes />
      <FaqLPs25
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgpngdesk={imgpngdesk}
        imgwebpdesk={imgwebpdesk}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
        linkMostrarTodasPerguntas={linkMostrarTodasPerguntas}
      />
      <style jsx>{Styles}</style>
    </>
  );
}

export default CDCProtegido25;
